import { render, staticRenderFns } from "./AssignTravelPolicyModal.vue?vue&type=template&id=ce4c64ec&scoped=true&"
import script from "./AssignTravelPolicyModal.vue?vue&type=script&lang=js&"
export * from "./AssignTravelPolicyModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignTravelPolicyModal.vue?vue&type=style&index=0&id=ce4c64ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4c64ec",
  null
  
)

export default component.exports